"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * カタカナ
 *
 * [ァ-ヺヽ-ヿ]
 *
 */
exports.KATAKANA_CHARS = "\u30A1-\u30FA\u30FD\u30FF";